/** WorkSuite module metadata for dashboard navigation (short One paths). */

export type WorkSuiteModuleId =
  | "mail-calendar"
  | "office-documents"
  | "transactional-email"
  | "video-meetings"
  | "messaging-voice"
  | "outlook-desktop"
  | "ai-voice";

export type WorkSuiteModuleSpec = {
  id: WorkSuiteModuleId;
  title: string;
};

export const WORKSUITE_MODULES: WorkSuiteModuleSpec[] = [
  { id: "mail-calendar", title: "Mail & calendar" },
  { id: "office-documents", title: "Office documents" },
  { id: "transactional-email", title: "Transactional email" },
  { id: "video-meetings", title: "Video meetings" },
  { id: "messaging-voice", title: "Messaging & voice" },
  { id: "outlook-desktop", title: "Outlook & mobile sync" },
  { id: "ai-voice", title: "AI-assisted calling" },
];

export function workSuiteModuleHref(id: WorkSuiteModuleId): string {
  return `/worksuite/modules/${id}`;
}
